import React from 'react';
import {
  CONTENT_TYPE_OPTIONS,
  PLACEMENT_OPTIONS,
  formatContentConfigForView,
  getDefaultContentConfig,
  getDefaultPlacementForType,
} from './utils/productDetailTabTypeHelpers';

function ProductDetailTabTypeDetailsFields({
  formData,
  sendDataToParent,
  readOnly = false,
  isEdit = false,
}) {
  const propagate = (next) => {
    if (sendDataToParent) sendDataToParent(next);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    propagate({ ...formData, [name]: value });
  };

  const handleContentTypeChange = (e) => {
    const contentType = e.target.value;
    propagate({
      ...formData,
      ContentType: contentType,
      ContentConfig: getDefaultContentConfig(contentType),
      Placement: getDefaultPlacementForType(contentType),
    });
  };

  const updateContentConfig = (patch) => {
    propagate({
      ...formData,
      ContentConfig: { ...(formData.ContentConfig || {}), ...patch },
    });
  };

  const excludeGroupsText = Array.isArray(formData.ContentConfig?.excludeSpecGroups)
    ? formData.ContentConfig.excludeSpecGroups.join(', ')
    : '';

  const handleExcludeGroupsChange = (value) => {
    const excludeSpecGroups = value
      .split(',')
      .map((item) => item.trim())
      .filter(Boolean);
    updateContentConfig({ excludeSpecGroups });
  };

  if (readOnly) {
    return (
      <div className="row">
        <div className="col-lg-6 mb-2"><strong>Tab Key:</strong> {formData.TabKey || '-'}</div>
        <div className="col-lg-6 mb-2"><strong>Default Title:</strong> {formData.DefaultTitle || '-'}</div>
        <div className="col-lg-6 mb-2"><strong>Content Type:</strong> {formData.ContentType || '-'}</div>
        <div className="col-lg-6 mb-2"><strong>Placement:</strong> {formData.Placement || '-'}</div>
        <div className="col-lg-12 mb-2"><strong>Content Config:</strong> {formatContentConfigForView(formData.ContentConfig)}</div>
        <div className="col-lg-12 mb-2"><strong>Help Text:</strong> {formData.HelpText || '-'}</div>
        <div className="col-lg-6 mb-2"><strong>Display Order:</strong> {formData.DisplayOrder ?? 0}</div>
      </div>
    );
  }

  const showSpecGroupField =
    formData.ContentType === 'spec_group_sidebar' || formData.ContentType === 'spec_group_table';
  const showExcludeGroupsField = formData.ContentType === 'spec_groups_table';

  return (
    <div className="row">
      <div className="col-lg-6">
        <div className="mb-3">
          <label className="form-label">
            Tab Key<span style={{ color: 'red' }}>*</span>
          </label>
          <input
            type="text"
            className="form-control"
            name="TabKey"
            value={formData.TabKey || ''}
            onChange={handleChange}
            disabled={isEdit}
            placeholder="general_details"
          />
        </div>
      </div>
      <div className="col-lg-6">
        <div className="mb-3">
          <label className="form-label">
            Default Title<span style={{ color: 'red' }}>*</span>
          </label>
          <input
            type="text"
            className="form-control"
            name="DefaultTitle"
            value={formData.DefaultTitle || ''}
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="col-lg-6">
        <div className="mb-3">
          <label className="form-label">
            Content Type<span style={{ color: 'red' }}>*</span>
          </label>
          <select
            className="form-select"
            name="ContentType"
            value={formData.ContentType || ''}
            onChange={handleContentTypeChange}
          >
            {CONTENT_TYPE_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className="col-lg-6">
        <div className="mb-3">
          <label className="form-label">Placement</label>
          <select
            className="form-select"
            name="Placement"
            value={formData.Placement || 'tab'}
            onChange={handleChange}
          >
            {PLACEMENT_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      </div>
      {showSpecGroupField ? (
        <div className="col-lg-12">
          <div className="mb-3">
            <label className="form-label">Spec Group Name</label>
            <input
              type="text"
              className="form-control"
              value={formData.ContentConfig?.specGroup || ''}
              onChange={(e) => updateContentConfig({ specGroup: e.target.value })}
            />
          </div>
        </div>
      ) : null}
      {showExcludeGroupsField ? (
        <div className="col-lg-12">
          <div className="mb-3">
            <label className="form-label">Exclude Spec Groups (comma-separated)</label>
            <input
              type="text"
              className="form-control"
              value={excludeGroupsText}
              onChange={(e) => handleExcludeGroupsChange(e.target.value)}
              placeholder="General Info, Description"
            />
          </div>
        </div>
      ) : null}
      <div className="col-lg-12">
        <div className="mb-3">
          <label className="form-label">Help Text</label>
          <textarea
            className="form-control"
            name="HelpText"
            rows={2}
            value={formData.HelpText || ''}
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="col-lg-6">
        <div className="mb-3">
          <label className="form-label">Display Order</label>
          <input
            type="number"
            className="form-control"
            name="DisplayOrder"
            value={formData.DisplayOrder ?? 0}
            onChange={handleChange}
          />
        </div>
      </div>
    </div>
  );
}

export default ProductDetailTabTypeDetailsFields;
